var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import * as T from "sb-resp-ui";
import { RacingRegionSwitcherRoot } from "../RacingRegionSwitcher";
import { RacingCurrentEventsRoot } from "../RacingCurrentEvents";
import { RacingFutureEventsRoot } from "../RacingFutureEvents";
import { RacingNextRacesRoot } from "../RacingNextRaces";
// external components
// import * as CMP from "./components";
// import * as SCMP from "../../components";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the RacingCombinedView component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
let RacingCombinedView = class RacingCombinedView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabActive: "current",
            dataProvider: this.props.dataProvider,
        };
        this.cachedState = {
            branchId: this.state.dataProvider.racingStore.branchId,
            regionId: this.state.dataProvider.racingStore.regionId
        };
        // window["t"] = this;
    }
    /* istanbul ignore next */
    componentDidMount() {
        // setup instances of the blocks
        // activate/deactivate is managed elsewhere
        this.internalBlocks = {
            region: new RacingRegionSwitcherRoot("racing-region-switcher", Object.assign({}, this.props.options)),
            nextRaces: new RacingNextRacesRoot("racing-next-races", Object.assign({}, this.props.options)),
            current: new RacingCurrentEventsRoot("racing-current-events", Object.assign({}, this.props.options), this.props.racingGameBlockNav),
            tomorrow: new RacingCurrentEventsRoot("racing-tomorrow-events", Object.assign({}, this.props.options), this.props.racingGameBlockNav),
            future: new RacingFutureEventsRoot("racing-future-events", Object.assign({}, this.props.options))
        };
        // link tabs instances
        this.tabsInstances = {
            current: this.internalBlocks.current,
            tomorrow: this.internalBlocks.tomorrow,
            future: this.internalBlocks.future
        };
        this.activateMain();
    }
    /* istanbul ignore next */
    activateMain() {
        // blocks active when the view first loads
        this.internalBlocks.region.activate();
        if (this.state.dataProvider.racingStore.isNextRacesAvailable) {
            this.internalBlocks.nextRaces.activate();
        }
        else {
            this.internalBlocks.nextRaces.deactivate();
        }
        this.internalBlocks.current.setParams(0);
        this.internalBlocks.current.activate();
        this.internalBlocks.tomorrow.setParams(1);
    }
    /* istanbul ignore next */
    deactivateAll() {
        Object.keys(this.internalBlocks).forEach(x => {
            typeof this.internalBlocks[x].deactivate === "function" && this.internalBlocks[x].deactivate();
        });
    }
    /* istanbul ignore next */
    componentWillUnmount() {
        this.deactivateAll();
    }
    /* istanbul ignore next */
    callTab(tab) {
        Object.keys(this.tabsInstances).forEach(x => this.tabsInstances[x][x === tab ? "activate" : "deactivate"]());
        this.setState({ tabActive: tab });
    }
    /* istanbul ignore next */
    renderTabTrigger(text, isDefault, link, dataUat) {
        return (React.createElement("div", { className: "rj-generic-tabs-01-outer", onClick: () => this.callTab(link) },
            React.createElement(T.TabTrigger, { default: isDefault, link: link, dataUat: dataUat },
                React.createElement("a", { className: "rj-generic-tabs-01" }, text))));
    }
    /* istanbul ignore next */
    renderTabBlock(id, link) {
        return (React.createElement(T.TabBlock, { link: link },
            React.createElement("div", { id: id })));
    }
    /* istanbul ignore next */
    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (this.cachedState.branchId !== this.state.dataProvider.racingStore.branchId ||
            this.cachedState.regionId !== this.state.dataProvider.racingStore.regionId) {
            return {
                branchId: this.state.dataProvider.racingStore.branchId,
                regionId: this.state.dataProvider.racingStore.regionId
            };
        }
        /* tslint:disable:no-null-keyword */
        return null;
        /* tslint:enable:no-null-keyword */
    }
    /* istanbul ignore next */
    componentDidUpdate(revProps, prevState, snapshot) {
        if (snapshot !== null) {
            this.deactivateAll();
            this.tabs && this.tabs.resetTabs();
            this.cachedState = snapshot;
        }
        this.activateMain();
    }
    render() {
        return (React.createElement("div", { "data-combined-active-view": this.state.tabActive, "data-combined-region": this.state.dataProvider.racingStore.regionId },
            React.createElement("div", { id: "racing-region-switcher" }),
            React.createElement("div", { id: "racing-next-races", "data-next-races": this.state.dataProvider.racingStore.isNextRacesAvailable }),
            React.createElement(T.Tabs, { ref: n => this.tabs = n },
                React.createElement("div", { className: "rj-generic-tabs-01-container" },
                    React.createElement(T.TabsTriggers, null,
                        this.renderTabTrigger(this.props.dict.TodayEvents, true, "current", "racing-combined-view-current-tab"),
                        this.state.dataProvider.racingStore.isTomorrowEventsPresent &&
                            this.renderTabTrigger(this.props.dict.TomorrowEvents, false, "tomorrow", "racing-combined-view-tomorrow-tab"),
                        this.state.dataProvider.racingStore.isFutureEventsPresent &&
                            this.renderTabTrigger(this.props.dict.AntepostEvents, false, "future", "racing-combined-view-future-tab"))),
                React.createElement("div", { className: "racing-combined-view__tabs-blocks" },
                    React.createElement(T.TabsBlocks, null,
                        this.renderTabBlock("racing-current-events", "current"),
                        this.renderTabBlock("racing-tomorrow-events", "tomorrow"),
                        this.renderTabBlock("racing-future-events", "future"))))));
    }
};
RacingCombinedView = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RacingCombinedView);
export { RacingCombinedView };
//# sourceMappingURL=RacingCombinedView.js.map